import React from 'react';
import { useAppDispatch, useAppSelector } from '@app/core/hooks/redux-hooks';
import { setExpandAllDiscountRateOverride } from '@app/core/store/ui-values-slice';
import styles from './expandall.module.scss';
import { FormProvider, useForm } from 'react-hook-form';
import { formConfigBase } from '@app/shared/constants/form-config-base';
import { useLocale } from '@app/core/hooks/useLocale';
import { Toggle, ToggleSize } from '../toggle/Toggle';

const ExpandAllDiscountRateOverride: React.FC = () => {
  const dispatch = useAppDispatch();
  const { l } = useLocale();
  const expandAll = useAppSelector((state) => state.uiValues.expandAllDiscountRateOverride);

  const handleChange = () => {
    dispatch(setExpandAllDiscountRateOverride(!expandAll));
  };

  const formMethods = useForm({
    ...formConfigBase,
  });

  return (
    <FormProvider {...formMethods}>
      <Toggle
        name="expandAllDiscountRateOverride"
        label={l('_ExpandAllRows')}
        toggleSize={ToggleSize.Medium}
        className={styles['expand-all']}
        forceChecked={expandAll}
        onChange={handleChange}
        ignoreReadOnly
        data-testid="expand-all-discount-rate-override-toggle"
      />
    </FormProvider>
  );
};

export default ExpandAllDiscountRateOverride;
